import { Box } from "@mantine/core";
import { useScrollVisibility } from "hooks/useScrollVisibility";
import { Outlet } from "react-router";
import HeaderResponsive from "../HeaderResponsive";
import OfflineBar from "./OfflineBar";

const TemporaryLayout: React.FC = () => {
  const visible = useScrollVisibility();

  return (
    <div className="min-h-screen flex flex-col font-work-sans">
      <HeaderResponsive visible={visible} />
      <Box
        ff={"Work Sans"}
        fz={"sm"}
        lh={"sm"}
        bg={"gray.1"}
        className="flex flex-col flex-1 relative"
      >
        <Outlet />
      </Box>
      <OfflineBar />
    </div>
  );
};

export default TemporaryLayout;
